import React from 'react'
import { I18n } from '@front/volcanion'

import { ConfirmationDialog } from '@front/squirtle'
import { SuspensionPopupForm } from '@abra/elements/Suspensions'
import ShowActiveJobsPopup from '@abra/elements/Popup/ShowActiveJobs'

const Dialogs = ({ record_id, onConfirmResetIdentifier }) => (
  <>
    <ConfirmationDialog
      name={'confirm_reset_identifier'}
      onConfirm={onConfirmResetIdentifier}
      title={I18n.t('identifier.reset.title')}
      description={I18n.t('identifier.reset.description')}
    />
    <SuspensionPopupForm record_id={record_id} model_name={"companyuser"} />
    <ShowActiveJobsPopup />
  </>
)

export default React.memo(Dialogs)
